import React, {useContext} from "react";

import { TranslationsContext } from "../../../_contexts";

export default function Code({ code }) {


  const translations = useContext(TranslationsContext);

  const formatCode = (rawCode) => {
    const formattedCode = rawCode.match(/.{1,4}/g).join("  ");
    return formattedCode;
  }

  return (
    <div className="gc__giftcard_code">
      {formatCode(code)}
    </div>
  )
}
